// Direct payment links for each plan
export const PAYMENT_LINKS = {
  premium: {
    monthly: 'https://buy.stripe.com/dR62a787Ecng9YkeUX?success_url=https://kontty.com/success?plan=premium',
    yearly: 'https://buy.stripe.com/00g5mj1Jg1ICgmI3ce?success_url=https://kontty.com/success?plan=premium_yearly'
  },
  pro: {
    monthly: 'https://buy.stripe.com/dR6bKHdrYbjc5I4cMN?success_url=https://kontty.com/success?plan=pro',
    yearly: 'https://buy.stripe.com/3csdSPafM5YSb2o8ww?success_url=https://kontty.com/success?plan=pro_yearly'
  }
};

export const redirectToCheckout = (planId: string, isYearly: boolean = false) => {
  const planLinks = PAYMENT_LINKS[planId as keyof typeof PAYMENT_LINKS];
  if (!planLinks) {
    throw new Error('Invalid plan selected');
  }

  // Always include the success_url parameter to ensure proper redirection
  const checkoutUrl = isYearly ? planLinks.yearly : planLinks.monthly;
  
  // Extract the base URL without any parameters
  const baseUrl = checkoutUrl.split('?')[0];
  
  // Add success_url parameter explicitly to ensure it's always included
  const successUrl = encodeURIComponent(`${window.location.origin}/success?plan=${isYearly ? planId + '_yearly' : planId}`);
  const finalUrl = `${baseUrl}?success_url=${successUrl}`;
  
  window.location.href = finalUrl;
};